import axios from "axios";
import * as bluebird from "bluebird";
import BigNumber from "bignumber.js";
declare global {
  var axios: any;
  var bluebird: any;
  var BigNumber: any;

  interface MerchologyEnvironment {
    SHOPIFY_MERCHOLOGY_STOREFRONT_URL: string,
    SHOPIFY_MERCHOLOGY_STOREFRONT_TOKEN: string,
  }
  interface ProductDetails {
    isALCPricingProduct: boolean,
    isHardGoodsProductType: boolean,
  }
  interface MerchologySettings {
    ProductDetails: ProductDetails,
    ProductOptions: any,
    Environment: MerchologyEnvironment
  }

  var Merchology: MerchologySettings;
}
window.axios = axios;
window.bluebird = bluebird;
window.BigNumber = BigNumber;